var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHide = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16C14.2782 16 16.125 14.1532 16.125 11.875C16.125 9.59683 14.2782 7.75 12 7.75C9.72183 7.75 7.875 9.59683 7.875 11.875C7.875 14.1532 9.72183 16 12 16Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9394 1L23 2.06058L3.06058 22L2 20.9394L21.9394 1Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5C5.125 5 1 11.8324 1 11.8324C1 11.8324 5.125 18.75 12 18.75C18.875 18.75 23 11.875 23 11.875C23 11.875 18.875 5 12 5ZM12 17.375C5.98438 17.375 2.71875 11.875 2.71875 11.875C2.71875 11.875 5.98438 6.375 12 6.375C18.0156 6.375 21.2812 11.875 21.2812 11.875C21.2812 11.875 18.0156 17.375 12 17.375Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHide);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hide.c2a8b35c7b094e12298258e796fbf5d9.svg";